import { zaokr, zl } from "../../../../functions/utilities";

const MieszkaniecDaneWodaRozliczenieWydrukKoszty = props => {
    
    const { rozliczenieWodyAkt, procent } = props;    
    return (
        <section style={{display: "flex", justifyContent: "center", marginBottom: "30px", fontSize: "0.85rem"}}>
            <table style={{fontSize: "0.7rem"}}>
                <tbody>
                    <tr>
                        <td style={{textAlign: "left", paddingLeft: "15px"}}>
                            Zimna woda:
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`(${procent?.zuzycieMieszkancaZimna} m³ + ${procent?.zuzycieMieszkancaCiepla} m³)`}
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            x
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${zl(rozliczenieWodyAkt?.metr_3_zimnej)}`}
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            =
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${zl(procent.kosztZimnej)}`}
                        </td>
                    </tr>
                    {
                        rozliczenieWodyAkt?.abonament_dzien > 0 && (
                            <tr>
                                <td style={{textAlign: "left", paddingLeft: "15px"}}>
                                    Koszt abonamentu:
                                </td>
                                <td style={{textAlign: "center", padding: "5px 10px"}}>
                                    {`${procent?.metraz} m²`}
                                </td>
                                <td style={{textAlign: "center", padding: "5px 10px"}}>
                                    x
                                </td>
                                <td style={{textAlign: "center", padding: "5px 10px"}}>
                                    {`${zaokr(procent?.abonament_pozorny_msc)}zł x ${procent?.abonament_pozorny_mnoznik} mies.`}
                                </td>
                                <td style={{textAlign: "center", padding: "5px 10px"}}>
                                    =
                                </td>
                                <td style={{textAlign: "center", padding: "5px 10px"}}>
                                    {`${zl(procent?.abonament)}`}
                                </td>                            
                            </tr>
                        )
                    }
                    <tr>
                        <td style={{textAlign: "left", paddingLeft: "15px"}}>
                            Podgrzanie wody:
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${procent?.zuzycieMieszkancaCiepla} m³`}
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            x
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${zl(rozliczenieWodyAkt?.kosztPodgrzaniaCieplej)}`}
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            =
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${zl(procent?.podgrzanieWody)}`}
                        </td>                            
                    </tr>                        
                    <tr>
                        <td style={{textAlign: "left", paddingLeft: "15px"}}>
                            Razem koszt zużycia wody:
                        </td>
                        <td colSpan={3} style={{textAlign: "center", padding: "5px 10px"}}>
                            {`${zl(procent?.kosztZimnej)} + ${zl(procent?.abonament)} + ${ zl( procent?.podgrzanieWody ) }`}
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            =
                        </td>
                        <td style={{textAlign: "center", padding: "5px 10px"}}>
                            <span style={{fontWeight: "600"}}>
                                {zl(procent?.razemZwCwAbo)}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukKoszty;